import { render, staticRenderFns } from "./ProuniFamilyIncomeForm.vue?vue&type=template&id=1142229b&scoped=true&"
import script from "./ProuniFamilyIncomeForm.vue?vue&type=script&lang=ts&"
export * from "./ProuniFamilyIncomeForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniFamilyIncomeForm.vue?vue&type=style&index=0&id=1142229b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1142229b",
  null
  
)

export default component.exports